/**
 * Module: shared/limits
 * Role: Single-source-of-truth for numeric limits/caps shared across miniapp
 *       screens, hooks, and server-side flows.
 *
 * Uses: (none — pure constants)
 * Used by: hooks/useFileUpload, screens/flow/templates/UgcPhotoGridScreen
 *
 * Glossary: ai/glossary/buyer.md
 */

// SYMMETRIC LIMIT — sync with:
//   - flows/wb-standard.yaml (UGC checkpoint — # SYMMETRIC LIMIT comment)
//   - backend: any server-side cap on UGC photo count per checkpoint
export const MAX_UGC_PHOTOS = 5;

// SYMMETRIC LIMIT — sync with:
//   - miniapp/src/lib/imageResize.ts:MAX_OUTPUT_BYTES (post-encode ceiling = 5 MB)
//   - supabase/migrations/20260513120000_*.sql:179 (artefacts bucket file_size_limit = 10485760)
//   - supabase/migrations/20260627193000_*.sql (artefacts bucket allowed_mime_types)
// BUG-1304: input guard — raw file from device before re-encode. 50 MB protects against canvas OOM.
// After encode the output is bounded by MAX_OUTPUT_BYTES (5 MB) in imageResize.ts.
export const MAX_PHOTO_INPUT_BYTES = 50 * 1024 * 1024; // 50 MB

// SYMMETRIC LIMIT — sync with:
//   - miniapp/src/lib/imageResize.ts:MAX_DIMENSION_PX (selfie = 1280)
// BUG-1304: flow photo max dimension — higher than selfie to preserve receipt QR/text legibility (DA-7).
export const FLOW_PHOTO_MAX_DIM = 2048;

// SYMMETRIC LIMIT — sync with:
//   - src/screens/pantene/VideoUpload.tsx:26 (MAX_VIDEO_SIZE_BYTES = 209_715_200)
//   - backend: src/api/v2/buyer/_pantene_schemas.py (UploadUrlRequest.size_bytes le)
export const MAX_VIDEO_SIZE_BYTES = 209_715_200; // 200 MB

// Accepted video MIME types for upload bricks. Sync with Supabase `videos` bucket.
export const ACCEPTED_VIDEO_TYPES = ['video/mp4', 'video/quicktime'] as const;
